import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.0004,
			cy: 5.77778,
			r: 1.77778,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.0004,
			cy: 12.3334,
			r: 1.77778,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.0004,
			cy: 18.8891,
			r: 1.77778,
			fill: "black"
		})
	]
});
export { SvgMore as ReactComponent };
